'use strict';

app.controller("jobProfileController", ["$scope", "$state", "$timeout", '$modal', "hFormReference", "$stateParams", '$rootScope', 'hEvent', '$window', '$filter', 'hUser', 'JobDetailsBus', 'hUserLocation', 'userPermissions', 'brandServices', '$q', 'chatBotService', '$element', 'accessibilityToolsService', 'appLayoutViewService', 'localize', 'SharingWidgetService', 'outmatchAssessmentService',
    function ($scope, $state, $timeout, $modal, hFormReference, $stateParams, $rootScope, hEvent, $window, $filter, hUser, JobDetailsBus, hUserLocation, userPermissions, brandServices, $q, chatBotService, $element, accessibilityToolsService, appLayoutViewService, localize, SharingWidgetService, outmatchAssessmentService) {

        if (typeof(__clickIq) !== 'undefined') {
            try {
                __clickIq.Click("https://api.clickiq.co.uk", publicConfiguration.MandBClickIQClientKey, $stateParams.jobid);
            } catch (err) {
                console.error(err);
            }
        }

        hUser.isFromUK()
            .then(function (isFromUK) {
                $scope.isFromUK = isFromUK;
            });

    $scope.currentJob = $stateParams.jobid;

        $scope.showEditButton = false;
        self.OUTMATCH_CANDIDATE_STATUS = outmatchAssessmentService.OUTMATCH_CANDIDATE_STATUS;

    try {
        if ($stateParams.redirect) {
            $scope.redirectionInfo = JSON.parse($stateParams.redirect.replace(/&apos;/g, "'"));
        }
        else if (HStorageManager.get({
            storageLevel: HStorageManager.StorageLevels.SESSION,
            key: 'career_portal_redirection{{job}}',
            variables: {
                job: $scope.currentJob
            }
        })) {
                $scope.redirectionInfo = HStorageManager.get({
                    storageLevel: HStorageManager.StorageLevels.SESSION,
                    key: 'career_portal_redirection{{job}}',
                    variables: {
                        job: $scope.currentJob
                    }
                });
        }
    }
    catch (err) { console.error(err); }
    $scope.data = $scope.data || {};

    if($stateParams && $stateParams.utm_source){
        if (typeof($stateParams.utm_source) === 'string') {
            $scope.data.utm_source = $stateParams.utm_source;
        }
        else if ($stateParams.utm_source[0]) {
            $scope.data.utm_source = $stateParams.utm_source[0];
        }

        $scope.data.utm_source = $scope.data.utm_source.toLowerCase();

        if($scope.data.utm_source == "simply"){
            $scope.data.utm_source = "simplyhired";
        }

        if ($scope.data.utm_source === "kickstart") {
            $scope.isFromApprinticeJobPortal = true;
        }
    }
    /* Get Visibily options for JPLP
     // from util.js
     ==============================================*/
    $scope.data.visibility = getVisibilityForJPLP();
    $scope.data.isPrivateLink = $state.current && $state.current.isPrivateLink;
    $scope.data.isPrivateViaLinkJob = $state.current && $state.current.isPrivateViaLinkJob;
    if ($scope.data.isPrivateViaLinkJob) {
        $scope.data.privateJobKey = $state.current && $state.current.privateJobKey
    }

    //bind logged-in variable
    $scope.isEmployer = hUser && hUser.data && hUser.data.user && hUser.data.user.user_employer;

    $scope.$watch(function () {
        return hUser && hUser.data && hUser.data.user && hUser.data.user.user_employer;
    }, function (newVal, oldVal) {
        $scope.isEmployer = newVal;
    });

    var slideIndex = 0;
    var slideInterval;
    $scope.slide = function (value) {
        clearTimeout(slideInterval);
        slideIndex += value;
        var slides = $(window).width() <= 575 ? $(".job-header .carousel-slides"): $(".job-card .carousel-slides");

        if (slides.length) {
            slideInterval = setTimeout(function () {
                $scope.slide(1);
            }, 4000);
            if (slideIndex < 0) {
                slideIndex = slides.length - 1;
            } else if (slideIndex === slides.length) {
                slideIndex = 0;
            }
            for (var i = 0; i < slides.length; i++) {
                slides[i].style.display = 'none';
            }
            slides[slideIndex].style.display = 'block';
        }
    };

    $scope.slide(0);

    var isCarriChatBotEnabled;
    var jobApplyButtonsElm;
    var initJobApplyHandler = function () {
        var brandId = $scope.jobDetails.brand.id;

        chatBotService.getBrandSettings(brandId, {channels: ['WEB']}).then(function (setting) {
            $scope.data.isCarriBrandActivated = setting['carri_application_mode_activated'];
        });

        chatBotService.getJobApplyMode(brandId, $scope.jobDetails.job.Position.code)
            .then(function(mode) {
                $scope.mode = mode;
            }, function (e) {
                // We should show something to the user here.
            });

        chatBotService.getJobApplyFromMode(brandId, $scope.jobDetails.job.Position.code)
            .then(function (applyMode) {
                $scope.applyMode = applyMode;
            });

            var applying = false;
            var onApplyClicked = function (event) {
                if (applying) {
                    return;
                }
                applying = true;
                var tempJob = $(event.target);
                var jobId = $scope.jobDetails.job.id;
                var redirectToJobApply = function () {
                    $timeout(function () {
                        tempJob[0].click();
                        applying = false;
                    });
                };
                var triggerCarriChatBot = function () {
                    applying = false;
                    var payload = {
                        "job_id": jobId,
                    };
                    chatBotService.triggerCarriJobApply('apply_for_specific_job', payload);
                };
                var handleApplyByMode = function () {

                    if ($scope.mode === "CARRI_ONLY") {
                        triggerCarriChatBot();
                    } else {
                        redirectToJobApply();
                    }
                };
                //children brands not handled - just the top brand in GCP
                if (isCarriChatBotEnabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    handleApplyByMode();
                } else {
                    applying = false;
                }
            };

            jobApplyButtonsElm = $element.find('.job-apply-button-'+$scope.jobDetails.job.id);
            jobApplyButtonsElm.off("click").on("click", onApplyClicked);
        };

        var autoVideoPlay = function () {
            setTimeout(function () {
                $element.find('.media-img').click();
            }, 1000);
        }

        let initLanguagesSelector = () => {
            $scope.defaultLang =  localize.getLang();
            $scope.currentLang =  localize.getLang();
        };

        let loadMap = function () {

            var job = $scope.jobDetails.job;
            var theme = appLayoutViewService.getBrandTheme();
            var markerColor = theme.scheme_settings && theme.scheme_settings.accent_color;
            var jobLocationsStaticMap = [];
            for (var i = 0; i < job.JobLocation.length; i++) {
                jobLocationsStaticMap.push([""]);
                jobLocationsStaticMap[i].push(job.JobLocation[i].Location.latitude);
                jobLocationsStaticMap[i].push(job.JobLocation[i].Location.longitude);
            }
            var unsignedURL = $filter('googleStaticMap')({locations: jobLocationsStaticMap, color: markerColor});
            GatewayAPI.signGoogleStaticMapsURL(unsignedURL).then(function (resp) {
                $scope.signedStaticMap = resp.signed_url;
            }, function (err) {
                console.error(err);
            }).finally(function () {
                $scope.$evalAsync();
            });
        };

        let fillRestOfSkills = ()=> {
            let job = $scope.jobDetails.job;

            if (job.Skill.length > 6) {
                $scope.skillsLength = job.Skill.length - 6;
                $scope.otherSkills = '';
                for (let i = 6; i < job.Skill.length; i++) {
                    $scope.otherSkills += job.Skill[i].name + '<br>';
                }
                $('.last-skill-badge').attr('data-original-title', $scope.otherSkills);
            }
        };

        $(document).ready(() => {
            $(document).on('click', '.more-jobs .job-link', function (e) {
                e.preventDefault();
                const jobUrl = $(e.currentTarget).attr('id');
                window.location.href = jobUrl;
            });
        });

    var init = function () {
        var defer = $q.defer();

        $scope.languages = [
            {id: 'en', label: 'EN'},
            {id: 'fr', label: 'FR'},
            {id: 'es', label: 'ES'}];

        if ($(window).width() <= 575) {
            $('.job-header').addClass('active');
            $('.fixed-header-mobile').removeClass('active');
            $('.header-bar-mobile .job-arrangements-box').css('visibility', 'visible');
        } else {
            $('.job-header').removeClass('active');
            $('.fixed-header-mobile').addClass('active');
            $('.header-bar-mobile .job-arrangements-box').css('visibility', 'hidden');
        }

        JobDetailsBus.getJob($stateParams.jobid, $stateParams.pjt)
            .then(function (jobDetails) {
                $scope.jobDetails = jobDetails;
                $scope.isTenantJobEnabled = $scope.jobDetails.brand.public_services?.indexOf("TENANT_JOBS") > -1;
                var job = $scope.jobDetails.job;
                var brandId = $scope.jobDetails.brand.id;
                var positionCategory = job.Position.position_type.code;
                var positionCode = job.Position.code;


                if ($scope.jobDetails.brand.scheme_settings) {
                    let bannerColor = ($scope.jobDetails.brand.scheme_settings?.career_portal_banner_color || $scope.jobDetails.brand.scheme_settings?.accent_color || '#0088DD');
                    document.documentElement.style.setProperty('--career_portal_banner', bannerColor);
                } else {
                    document.documentElement.style.setProperty('--career_portal_banner', '#0088DD');
                }

                fillRestOfSkills();
                chatBotService.isCarriChatBotEnabled($scope.jobDetails.brand.id)
                    .then(function (isEnabled) {
                        isCarriChatBotEnabled = isEnabled;
                        initJobApplyHandler();
                    })
                    .catch(function (err) {
                        console.error(err);
                    });

                if (hUser.isEmployer()) {
                    var promises = {};
                    promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
                    promises['isJobApprovalFlowEnabled'] = brandServices.check(brandServices.SERVICES.JOB_APPROVAL_FLOW, brandId, true);
                    $q.all(promises)
                        .then(function (data) {
                            var policyParser = data['policyParser'];
                            $scope.isJobApprovalFlowEnabled = data['isJobApprovalFlowEnabled'];
                            $scope.hasOverrideJobApprovalPermission = policyParser.position(positionCategory, positionCode).has(userPermissions.PERMISSIONS.OVERRIDE_APPROVALS);
                            $scope.hasCreateEditJobPostPermission = policyParser.position(positionCategory, positionCode).has(userPermissions.PERMISSIONS.CREATE_EDIT_JOB_POST);
                            $scope.hasCreateEditJobPostFromTemplatePermission = policyParser.position(positionCategory, positionCode).has(userPermissions.PERMISSIONS.CREATE_JOB_POST_FROM_TEMPLATE);
                            $scope.hasCreateJobPostFromTemplateAndEditPartiallyPermission = policyParser.position(positionCategory, positionCode).has(userPermissions.PERMISSIONS.CREATE_JOB_POST_FROM_TEMPLATE_AND_PARTIALLY_EDIT);

                            if ($scope.isJobApprovalFlowEnabled) {
                                $scope.hasJobEditPermission = $scope.hasOverrideJobApprovalPermission && ($scope.hasCreateEditJobPostPermission || (job.template_id && $scope.hasCreateEditJobPostFromTemplatePermission) || (job.template_id && $scope.hasCreateJobPostFromTemplateAndEditPartiallyPermission));
                            } else {
                                $scope.hasJobEditPermission = $scope.hasCreateEditJobPostPermission || (job.template_id && $scope.hasCreateEditJobPostFromTemplatePermission) || (job.template_id && $scope.hasCreateJobPostFromTemplateAndEditPartiallyPermission);
                            }

                            defer.resolve();
                        })
                        .catch(function (err) {
                            console.error(err);
                            defer.reject(err);
                        });
                }
                else {
                    if ($scope.jobDetails.brand.accessibility_tool_settings && $scope.jobDetails.brand.accessibility_tool_settings.accessibility_usage_allowed) {
                        accessibilityToolsService.initAccessibilityTool($scope.jobDetails.brand.accessibility_tool_settings);
                        $scope.isAccessibilityButtonShown = true;
                    } else {
                        accessibilityToolsService.hideAccessibilityTool();
                    }
                    defer.resolve();
                }

                var profileImage;
                var rectangleProfileImage;
                if ($scope.jobDetails.brand.BrandMedia) {
                    profileImage = _.findWhere($scope.jobDetails.brand.BrandMedia, {'type': 'profile_image'});
                    rectangleProfileImage = _.findWhere($scope.jobDetails.brand.BrandMedia, {'type': 'rectangle_profile_image'});
                }
                appLayoutViewService.updateBrandTheme({
                    scheme_settings: jobDetails.brand.scheme_settings,
                    profile_image: profileImage || null,
                    rectangle_profile_image: rectangleProfileImage || null
                }, 'job_page_theme', $element.find(`.job-page-landing-page`).context)
                    .finally(function () {
                        $scope.$evalAsync();
                    });

                loadMap();

            });

        autoVideoPlay();
        //add if condition(language enabled)
        initLanguagesSelector();

        return defer.promise;
    };

    init();

    $scope.changeLanguage = function (languageCode) {
        let toLang = languageCode || $scope.defaultLang;

        HStorageManager.put({
            key: 'lang',
            storageLevel: HStorageManager.StorageLevels.COOKIES,
            value: toLang,
            codec: false
        });
        hEvent.track(
            "language_change",
            {
                "to": toLang,
                "from": $scope.currentLang,
                "page": $state.current.name
            },
           async function () {

                if (hUser.isLoggedIn()) {

                    await SettingsAPI.saveUserLocale(toLang);
                    hRedirect(hGetCurrentUrl(toLang));

                } else {
                    hRedirect(hGetCurrentUrl(toLang));
                }
            });
    };

    $scope.close = function (){
        $scope.showLocationMobilePanel = false;
    };

    $scope.showAccessibilityTools = function () {
        accessibilityToolsService.showAccessibilityTool();
    };

    $scope.showShareList = function () {
        $scope.isSharedListOpened = !$scope.isSharedListOpened;
    };

    $scope.showLocationList = function () {
            $scope.showLocation = !$scope.showLocation;
    };

    $scope.showLocationMobileList = function () {
        $scope.showLocationInMobile = !$scope.showLocationInMobile;
    };

    $('.all-locations-mobile-backdrop').on("click", function () {
        $scope.showLocationMobileList();
        $scope.$digest();
    });

    $(document).on('click', function (event) {
        var target = $(event.target);

        if (!target.closest('.get-direction-map-btn, .location-list').length) {
            $scope.showLocation = false;
            $('.location-list').removeClass('open');
            $scope.$digest();
        }

        if (!target.closest('.share-button').length) {
            $scope.isSharedListOpened = false;
            $('.share-list').removeClass('open');
            $scope.$digest();
        }

    });


    $scope.showLocationPanel = function () {
            $scope.showLocationMobilePanel = !$scope.showLocationMobilePanel;
    };

    const getJobURL = () => {
        let positionSlug = $filter('userPosition')({
            'Position': $scope.jobDetails.job.Position,
            'custom_position': $scope.jobDetails.job.alias_position
        });
        let linkHostname =`${window.location.protocol}//${window.location.hostname}`;
        let jobURL =`${$scope.jobDetails.brand.slug}/job/${$scope.jobDetails.job.id}-${$filter('username')(positionSlug)}`;
        let privateViaLinkToken = $scope.jobDetails.job.private_via_link_settings?.private_key;

        if ($scope.jobDetails.job.access_mode === JobAPI.JOB_POST_TYPES.PRIVATE) {
            return `${linkHostname}/internal/${jobURL}`;
        } else if ($scope.jobDetails.job.access_mode === JobAPI.JOB_POST_TYPES.PRIVATE_VIA_LINK) {
            return `${linkHostname}/${jobURL}?pjt=${privateViaLinkToken}`;
        } else {
            return `${linkHostname}/${jobURL}`;
        }
    }

    let getEmailURL = () => {
        $scope.url = getJobURL();
        let emailURL = $scope.url;
        if (emailURL && emailURL.indexOf('http') != 0) {
            /* add / to URL if not exisit */
            if (emailURL.indexOf('/') != 0) {
                emailURL = '/' + emailURL;
            }
            emailURL = getBaseURL() + emailURL;
        }
        //encodeURI
        return emailURL;
    };

        //Re-init the sharing URL on change
    $scope.getMail = () => {
        if ($scope.emailBody) {
            $scope.emailBody = $scope.emailBody.includes('utm_source') ?
                $scope.emailBody.replace(new RegExp('social','g'), 'email') :
                $scope.emailBody + '&' + 'utm_source=' + encodeURIComponent('email');
        }

        let emailBody = $scope.emailBody || getEmailURL();
        $scope.emailString = 'mailto:?';
        if ($scope.emailSubject) {
            $scope.emailString += 'Subject=' + encodeURIComponent($scope.emailSubject);
        }
        $scope.emailString += ($scope.emailSubject ? '&' : '') + 'body=' + encodeURIComponent(emailBody);
        if ($scope.emailString) {
            if ($scope.emailString.includes('utm_source')) {
                $scope.emailString = $scope.emailString.replace(new RegExp('social','g'), 'email');
            } else {
                $scope.emailString += '&' + 'utm_source=' + encodeURIComponent('email');
            }
        }

        window.open($scope.emailString, '_blank');
    };

    $scope.getUrlSocialMedia = function (source) {
        let jobUrl = getJobURL();
        let output = SharingWidgetService.getSocialMediaUrl(source, jobUrl);
        window.open(output, '_blank');
    };


    $scope.copyLink = function () {
        var textArea = document.createElement("textarea");
        textArea.value = window.location.href;
        document.body.appendChild(textArea);
        textArea.focus();

        try {
            textArea.select();
        } catch (e) {}

        try {
            textArea.setSelectionRange(0, textArea.value.length);
        } catch (e) {}

        var successful = document.execCommand('copy');
        if (successful) {
            HNotifications.show({
                title: $filter("translate")("Job link copied to clipboard."),
                desc: '',
                icon: "fa-check",
                type: "success",
                timeout: 3000
            });
        };

        document.body.removeChild(textArea);

    };

    $scope.editJob = function () {
        if ($scope.isJobApprovalFlowEnabled &&
            !(
                $scope.hasOverrideJobApprovalPermission &&
                $scope.hasCreateEditJobPostPermission
            )
        ) {
            hAlert(
                $filter("translate")("Not enough permissions"),
                $filter("translate")("You cannot edit an approved job directly, Please contact your HR team.")
            );
        } else {
            hRedirect('job/create/' + $scope.currentJob);
        }
    };

    /* a Hack to display welcoming message on one line for job view 2
     =====================================================================*/
    if($('.h-job-profile').hasClass('h-job-profile2')){
        var oldHeight = $('.h-job-profile2 .out-welcome-note').height();
        //addingPaddingValue
        oldHeight = oldHeight+10;
        if(oldHeight>35){
            $('.h-job-profile2 .out-welcome-note').css('height','35px');
            var _toggleSpan = $('<span class="w-togglespan active"><i class="fa fa-plus"></i> '+$filter("translate")("more")+'</span>');
            $('.h-job-profile2 .out-welcome-note').append(_toggleSpan);
            $('.h-job-profile2 .out-welcome-note').addClass('can-toggle');
            $('.h-job-profile2 .out-welcome-note .w-togglespan').click(function (){
                if($(this).hasClass('active')){
                    $('.h-job-profile2 .out-welcome-note').css('height','auto');
                    $(this).html('<i class="fa fa-minus"></i> '+$filter("translate")("less"));
                    $(this).removeClass('active');
                }else{
                    $('.h-job-profile2 .out-welcome-note').css('height','35px');
                    $(this).addClass('active');
                    $(this).html('<i class="fa fa-plus"></i> '+$filter("translate")("more"));
                }
            });
        }
    }


    $scope.open_apply = function (job_id) {
        $state.go('.apply', {
            'job_id': job_id
        });
    };


    /**
     * Get the Page Referal
     */

        // Handle Search Referal
    $scope.referal = $state.href('appLayout.harriSH.search.jobs'); //Default Referal
    if( $rootScope.referal && $rootScope.referal.state && $rootScope.referal.state.name && $rootScope.referal.state.name.indexOf('appLayout.harriSH.search.jobs') != -1 ){
        $scope.referal = $state.href( $rootScope.referal.state.name , $rootScope.referal.params );
    }else if( HStorageManager.get({
        storageLevel: HStorageManager.StorageLevels.COOKIES,
        key: 'previous_search',
    }) ){
        $scope.referal = HStorageManager.get({
            storageLevel: HStorageManager.StorageLevels.COOKIES,
            key: 'previous_search',
        });
    }

    // Add Referal to Cookies to hanle referesh
    HStorageManager.put({
        storageLevel: HStorageManager.StorageLevels.COOKIES,
        key: 'previous_search',
        value: $scope.referal
    });

    // Clear Cookie on exit
    $scope.$on(
      "$destroy",
      function handleScopeDestroy() {
          jobApplyButtonsElm.off("click");

          if(($rootScope.$previousState && $rootScope.$previousState.indexOf('.apply') == -1) || !deviceChecker.isMobile()){
              HStorageManager.remove({
                  storageLevel: HStorageManager.StorageLevels.COOKIES,
                  key: 'previous_search'
              });
          }

          JobDetailsBus.onJobApplyFinish = function () {};
          JobDetailsBus.onJobApplyUpdate = function () {};
      }
    );

    $scope.modal = {};

    $scope.goToDashboard = function(){
        $('#apply-modal.modal').modal('hide');
        $('.modal-backdrop').remove();

        $state.go('appLayout.harriSH.dashboard');
    }

    setTimeout(function(){
        var modalFirstJPLP = HStorageManager.get({
            storageLevel: HStorageManager.StorageLevels.COOKIES,
            key: 'modalFirstJPLP',
        });

        if(!modalFirstJPLP){
          if($scope.data.utm_source == "craigslist" || $scope.data.utm_source == "indeed" || $scope.data.utm_source == "simplyhired"){
              if($('#job-view-2').length>0){
                  $('#job-view-2').modal('show');
                  HStorageManager.put({
                      storageLevel: HStorageManager.StorageLevels.COOKIES,
                      key: 'modalFirstJPLP',
                      value: true
                  });
              }
          }
        }
    }, 0);


    /* Toggle Skills
     ============================================*/
    $scope.toggleSkills = function (){
        $scope.data.visibility.skills.collapsed = !$scope.data.visibility.skills.collapsed;
    }

    /* Toggle Details
     ===========================================*/
    $scope.toggleDetails = function (){
        $scope.data.visibility.details.collapsed = !$scope.data.visibility.details.collapsed;
    }

    /* Toggle Descirption
    =============================================*/
    $scope.descriptionToggle = function(){
        $scope.descriptionCollapsed = !$scope.descriptionCollapsed;
        //if(!$scope.descriptionCollapsed){

            /* Hack to solve the scroll bar probelm in modal job view
            =====================================*/
           if($('#job-view-2').length>0){
               $('#job-view-2').scrollTop(0);
               $('#job-view-2').hide().show(0);
               $('body').hide().show(0);
            }
        //}
    }

    /* Recalculate stickyLine
     =============================================*/
    $scope.ctrlObject = {};
    $scope.collapseTextToggled = function () {
        $timeout(function () {
            $scope.ctrlObject.updateStickyLine();
        },0);
    }

    /* Hack to solve width issue for apply job button (Change Later)
    ========================================================*/
    angular.element(window).on('resize',function(){
        var width_ = $('.profile .user-card').css('width');
        width_ = parseInt(width_);
        $('.fixed-width-sticky').css('width', width_ + 'px');


        if ($(window).width() <= 575) {
            $('.job-header').addClass('active');
            $('.fixed-header-mobile').removeClass('active');
            $('.header-bar-mobile .job-arrangements-box').css('visibility', 'visible');
        } else {
            $('.job-header').removeClass('active');
            $('.fixed-header-mobile').addClass('active');
            $('.header-bar-mobile .job-arrangements-box').css('visibility', 'hidden');
        }
    });


        // Start congratulations logic
        JobDetailsBus.onJobApplyUpdate = function (status, appId, applyDate) {
            switch (status) {
                case JobDetailsBus.SUCCESS:
                case JobDetailsBus.SUCCESS_NO_PASSWORD:
                    $(".reapply-already-applied").hide();
                    $(".apply-btn").attr("class", "btn btn-block apply-btn already-applied");
                    $(".apply-btn").attr("aria-label", $filter('translate')("Applied Successfully"));
                    $(".apply-btn span").text($filter('translate')('Applied Successfully'));

                    break;
                case JobDetailsBus.DRAFTED:

                    $(".reapply-already-applied").hide();
                    $(".apply-btn").attr("class", "btn btn-block apply-btn drafted");
                    $(".apply-btn").attr("aria-label", $filter('translate')("Drafted, Complete Application")+' '+$filter('translate')($scope.jobDetails.job.alias_position || $scope.jobDetails.job.position)+' '+$filter('translate')('at')+' '+($scope.jobDetails.brand.external_business_name || $scope.jobDetails.brand.name));
                    $(".apply-btn span").text($filter('translate')('Drafted, Complete Application'));

                    break;
                case JobDetailsBus.DISCARDED:
                    // No change
                    break;

                case JobDetailsBus.APPLIED:

                    $(".apply-btn").attr("class", "btn btn-block apply-btn already-applied");
                    $(".apply-btn").attr("aria-label", $filter('translate')('Applied on ' + moment(applyDate).format("MMMM Do, YYYY")));
                    $(".apply-btn span").text($filter('translate')('Applied on ' + moment(applyDate).format("MMMM Do, YYYY")));

                    break;

                case JobDetailsBus.EXPIRED:

                    $(".apply-btn").attr("class", "btn btn-block h-lg-gray-outline-btn btn-no-cursor h-text");
                    $(".apply-btn span").text($filter('translate')('Expired job post'));

                    break;
            }
        };

        JobDetailsBus.onJobApplyFinish = async (status, appId, applyDate) => {
            if ([JobDetailsBus.SUCCESS, JobDetailsBus.SUCCESS_NO_PASSWORD].indexOf(status) > -1) {
                if($scope.jobDetails.brand.public_services && $scope.jobDetails.brand.public_services.indexOf("WOTC") > -1) {
                    WOTCAPI.getBrandWotcSettings($scope.jobDetails.brand.id)
                        .then(async (res) => {
                            if(res['workflow_mode'] === 'IN_APPLICATION') {
                                $state.go('.wotc', {
                                    brand_id: $scope.jobDetails.brand.id,
                                    job_id:  $scope.jobDetails.job.id,
                                    app_id: appId
                                });
                            }
                            else {
                                await handleOutmatchAssessment($scope.jobDetails, $scope.jobDetails.brand.id, status, appId, $scope.jobDetails.job.id);
                            }
                            $scope.$digest();
                        })
                        .catch(async (err) => {
                            console.error(err);
                            await handleOutmatchAssessment($scope.jobDetails, $scope.jobDetails.brand.id, status, appId, $scope.jobDetails.job.id);
                        })
                }
                else {
                    await handleOutmatchAssessment($scope.jobDetails, $scope.jobDetails.brand.id, status, appId, $scope.jobDetails.job.id);
                }
            }
            else if([JobDetailsBus.WOTC_NOT_COMPLETED, JobDetailsBus.WOTC_SUCCESS].indexOf(status) > -1) {
                await handleOutmatchAssessment($scope.jobDetails, $scope.jobDetails.brand.id, status, appId, $scope.jobDetails.job.id);
            }
        };

        const handleOutmatchAssessment = async (jobDetails, brandId, status, appId, jobId) => {
            const nextFlowCallback = () => {
                showApplySuccessModal(status);
            };
            await outmatchAssessmentService.processOutmatchAssessment(jobDetails, brandId, status, appId, jobId, nextFlowCallback);
        };

        $scope.trackRecommendedJobClick = function (recommendedJobId) {
            window.referer = 'post-apply';
            hEvent.track("recommended_job_click", { category: 'job_apply', label: recommendedJobId });
        };

        $scope.trackEnhanceProfileClick = function (profileScore) {
            hEvent.track("enhance_profile_click", { category: 'job_apply', label: profileScore });
        };

        $scope.scrollTo = function (id) {

            var topFixedSpace;

            if ($('.header-bar-mobile').hasClass('fixed-bar')) {
                topFixedSpace = 135;
            } else {
                topFixedSpace = 185;
            }

            $('body').css('height', 'unset');

            $('html, body').animate({
                scrollTop: $('#' + id).offset().top - topFixedSpace
            }, 600);
        };


        $(window).scroll(function () {
            var paddingFromTop = 0;
            if($('harri-header').length){
                paddingFromTop += 73;
            }
            var windowScrollTop = $(window).scrollTop();

            if ($(window).width() <= 575) {
                if (windowScrollTop > 0) {
                    $('.fixed-header-mobile').addClass('active');
                    $('.job-header').removeClass('active');
                    $('.header-bar-mobile .job-arrangements-box').css('visibility', 'hidden');
                } else {
                    $('.fixed-header-mobile').removeClass('active');
                    $('.job-header').addClass('active');
                    $('.header-bar-mobile .job-arrangements-box').css('visibility', 'visible');
                }
            } else {
                $('.fixed-header-mobile').addClass('active');
                $('.job-header').removeClass('active');
                $('.header-bar-mobile .job-arrangements-box').css('visibility', 'hidden');
            }

            if (($(window).width() <= 575) &&
                !$('.header-bar-mobile').hasClass('fixed-bar') &&
                windowScrollTop + paddingFromTop > ($('.header-bar-mobile').position() && $('.header-bar-mobile').position().top)) {
                $('.header-bar-mobile').addClass('fixed-bar');
            } else if (($(window).width() <= 575) &&
                $('.header-bar-mobile').hasClass('fixed-bar') &&
                windowScrollTop <= $('.header').height()) {
                $('.header-bar-mobile').removeClass('fixed-bar');
            }

            var reachedId = ['job_summery', 'job_description', 'job_requirements', 'job_skills'].find(function (id) {

                if ($('#' + id) && $('#' + id).offset() &&
                    (windowScrollTop + 140) > $('#' + id).offset().top &&
                    (windowScrollTop + 140) < $('#' + id).offset().top + $('#' + id).height() + 45
                ) {
                    return true;
                }
            });

            if (reachedId) {
                $('.' + reachedId).siblings().removeClass('active').end().addClass('active');
            } else if (!$('.header-bar-mobile').hasClass('fixed-bar')) {
                $('.job_summery').siblings().removeClass('active').end().addClass('active')
            } else {
                $('.header-bar-mobile ul li').removeClass('active');
            }

        });



        var showApplySuccessModal = function (status) {

            $scope.isPrivacyShield = hUser.isPrivacyShieldOn();
            $scope.profileScore = 0;
            $scope.WEAK = DashboardAPI.WEAK;
            $scope.GOOD = DashboardAPI.GOOD;
            $scope.MODERATE = DashboardAPI.MODERATE;
            $scope.OUTSTANDING = DashboardAPI.OUTSTANDING;
            $scope.completedWotc = status == JobDetailsBus.WOTC_SUCCESS;
            if ($scope.redirectionInfo) {
                $scope.isCareerPortalEnabled = true;
            }
            else {
                $scope.isCareerPortalEnabled = false;
            }

            // As reloadOnSearch is set to false (to avoid refreshing the page on query params changes e.g. utm_source)
            // This is a workaround to force reload the page when a recommended job is for the same brand (same state)
            // TODO: Upgrade ui-router will fix this issue
            $scope.forceGoTo = function (jobId, positionTitle) {
                var originalReloadOnSearch = $state.current.reloadOnSearch;
                $state.current.reloadOnSearch = undefined;
                $state.go('.', {jobid: jobId, title: positionTitle}, {notify: true})
                    .then(function () {
                        $state.current.reloadOnSearch = originalReloadOnSearch;
                    });
            };

            JobDetailsBus.getJob($stateParams.jobid, $stateParams.pjt)
                .then(function (jobDetails) {

                    var promises = {};
                    if (hUser.isLoggedIn()) {
                        promises['profile_strength'] = DashboardAPI.getProfileStrength();
                    }

                    $q.all(promises)
                        .then(function (result) {
                            var data = result['profile_strength'];

                            $('#apply-success-modal')
                                .on('show.bs.modal', function () {
                                    setTimeout(function () {
                                        $('#apply-success-modal').removeClass('before-animation');
                                    }, 250);
                                })
                                .on('hide.bs.modal', function () {
                                    $('#apply-success-modal').addClass('before-animation');
                                    if (status === JobDetailsBus.SUCCESS_NO_PASSWORD) {
                                        logoutUser();
                                    }
                                }).modal('show');

                            setTimeout(function () {
                                if ($('#apply-success-modal').find('.modal-footer').find('a')[0]) {
                                    $('#apply-success-modal').find('.modal-footer').find('a')[0].focus()
                                }
                            },500);

                            if (data) {
                                $scope.profileScore = data.profStrength;
                                $scope.profileStrengthCode = data.code;

                                $scope.successData = [{
                                    job: jobDetails.job,
                                    brand: jobDetails.brand
                                }];

                                if (hUser.isPrivacyShieldOn() || data.profStrength < 50 || data.items_list.indexOf("profile_photo") > -1) {
                                    $scope.profileSuggestedActions = data.missingItems;
                                    hEvent.track("success_shown", { category: 'job_apply', label: hUser.isPrivacyShieldOn()? 'privacy_shield': 'profile_strength_' + data.profStrength });
                                }
                                else {
                                    $scope.isLoadingRecommJobs = true;

                                    hUserLocation.getLocation()
                                        .then(function (userLocation) {
                                            var locations = [];
                                            var positions = [jobDetails.job.Position.name];
                                            var hecs = [(jobDetails.brand.hecs[0] && jobDetails.brand.hecs[0].name)];
                                            var categories = [];

                                            if (userLocation.latitude && userLocation.longitude) {
                                                locations.push(userLocation.latitude.toString());
                                                locations.push(userLocation.longitude.toString());
                                            }

                                            RecommendationAPI.loadJobs(3, locations, positions, hecs, categories)
                                                .then(function (jobs) {
                                                    $scope.isLoadingRecommJobs = false;
                                                    $scope.recommendedJobs = jobs;

                                                    if (!jobs.length) {
                                                        // Show profile score, if there are no recommendations
                                                        $scope.profileSuggestedActions = data.missingItems;
                                                    }

                                                    hEvent.track("success_shown", { category: 'job_apply', label: 'recommend_jobs_' + jobs.length });

                                                    $scope.$digest();
                                                });
                                        });
                                }
                            }

                            if (JobDetailsBus.getIsNoPassword(jobDetails.job.id)) {
                                $scope.isPrivacyShield = false;
                                $scope.isNoPassword = true;
                                hEvent.track("success_shown", { category: 'job_apply', label: 'no_password' });
                            }
                        });

                });
        };

        var logoutUser = function () {
            var redirectUrl =  window.location.href;
            hLoginManager.signOut(redirectUrl);
        };

        $scope.onSearchOpen = function (isShown) {
            $scope.searchOpen = isShown;
            $scope.$evalAsync();
        };

        $scope.isSideBarExpanded = function () {
            return appLayoutViewService.isSideBarExpanded();
        };

        $scope.getToggleSource = function () {
            return appLayoutViewService.getToggleSource();
        };

    }]);

app = angular.module('harriApp');

app.controller('AtsController', ['$scope','$stateParams','$sce', function($scope,$stateParams,$sce){

    $('body').removeClass('modal-open');
    var url = $sce.trustAsResourceUrl(decodeURIComponent($stateParams.url));

    if (!/^https?:\/\//i.test(url)) {
        url = 'http://' + url;
    }

    $scope.url = url;



}]);


/**
 * Recommended Jobs Widget
 */
app.directive('relatedJobsWidget', ['$state', '$location', 'encodeUrlQuery', 'googleMaps', '$filter', '$sce', function($state, $location, encodeUrlQuery, googleMaps, $filter, $sce){
  return{
    'restrict' : 'E',
    'scope' : {
      'limit' : '=?',
      'lat' : '=?',
      'lng' : '=?',
      'positions' : '=?',
      'hecs'  : '=?',
      'brandSlug'  : '@',
      'categories' : '=?',
      'ignoredJobs' : '=?',
      'brandId' : '=?',
      'isPrivacyShield' : '=?',
    },
    'templateUrl': "../modules/job_profile/views/partials/related-jobs-widget.html",
    'replace' : true,
    'link' : function( scope, element, attrs ){


      var EXCEPT_THESE_JOBS = [ 'generic position' ];

        // As reloadOnSearch is set to false (to avoid refreshing the page on query params changes e.g. utm_source)
        // This is a workaround to force reload the page when a recommended job is for the same brand (same state)
        // TODO: Upgrade ui-router will fix this issue
        scope.forceGoTo = function (jobId, positionTitle) {
            var originalReloadOnSearch = $state.current.reloadOnSearch;
            $state.current.reloadOnSearch = undefined;
            $state.go('.', {jobid: jobId, title: positionTitle}, {notify: true})
                .then(function () {
                    $state.current.reloadOnSearch = originalReloadOnSearch;
                });
        };

      /**
       * Load Related Jobs
       * @param limit
       * @param location
       * @param positions
       * @param hecs
       * @param categories
       */
      let loadRelatedJobs = function( limit, location, positions, hecs, categories, ignoredJobs){
        RecommendationAPI.loadJobs(limit, location, positions, hecs, categories, ignoredJobs)
          .then(function( result ){
            scope.relatedJobs = result;
            scope.$digest();
          });
      };

      let loadRelatedJobsForBrand = async (limit, location, categories, ignoredJobs, brandId) => {
            let res = await RecommendationAPI.loadJobsFromSameBrand(limit, location, categories, ignoredJobs, brandId);
            scope.relatedJobs = res.results;
            scope.$digest();
      };

      scope.handleCompensation = (job) => {
          if (!scope.isPrivacyShield) {
              let jobCompensationObj = job.compensation[0]['JobCompensation'];
              let jobCompensationCode = jobCompensationObj.Compensation[0].code;

              jobCompensationObj['compensation'] = {
                  'code': jobCompensationCode,
                  'name': jobCompensationObj.Compensation[0].name
              };

              jobCompensationObj['compensation_rate'] = jobCompensationObj.CompensationRate && jobCompensationObj.CompensationRate[0];

              let brand = {Location: job.JobLocation, id: job.brand.id, withInfoIcon: true};
              scope.data = $filter('compensationFormatter')(jobCompensationObj, brand);

          } else {
              let JobCompensationObj = job.compensation;
              let jobCompensationCode = JobCompensationObj.code;

              JobCompensationObj['compensation'] = {
                  'code': jobCompensationCode,
                  'name': JobCompensationObj.name
              };

              JobCompensationObj['compensation_rate'] = JobCompensationObj.rate;

              let brand = {Location: job.locations, id: job.brand.id, withInfoIcon: true, isCareerPortal: true};
              scope.data = $filter('compensationFormatter')(JobCompensationObj, brand);
          };

          // Extract data-original-title value
          let originalTitle = /data-original-title="([^"]*)"/.exec(scope.data);
          if (originalTitle && originalTitle.length > 1) {
              let dataOriginalTitle = originalTitle[1];
              // Set title attribute to the value of data-original-title
              scope.data = scope.data.replace('<i class="fa fa-info-circle"', `<i class="fa fa-info-circle" title="${dataOriginalTitle}"`);
          }

          return $sce.trustAsHtml(scope.data);
      };

      /**
       * Directive Entry point
       */
      var init = function(){


        if( scope.positions && scope.positions.length && _.contains( EXCEPT_THESE_JOBS, scope.positions[0] ) ){
          return;
        }


        var searchObj = {
          'positions' : scope.positions
        };

        if( scope.lat && scope.lng ) {
          scope.location = [ scope.lat + "" , scope.lng + "" ];
          searchObj.location = scope.location;
        }

        scope.positions = !_.isEmpty( scope.positions[0] ) ? scope.positions : undefined;
        scope.hecs = !_.isEmpty( scope.hecs && scope.hecs[0] ) ? scope.hecs : undefined;



        if( scope.hecs ){
          searchObj.hecs = scope.hecs;
        }

        if( ! _.isEmpty( scope.ignoredJobs ) ){
          scope.ignoredJobs = _.without( scope.ignoredJobs , "" );
        }

        scope.searchUrl = '/jobs' + encodeURIComponent( encodeUrlQuery(searchObj) );

          scope.goToSearchPage = function () {
              /**
               * Add location label to the location object
               */
              googleMaps.locationAutocomplete(scope.lat + "," + scope.lng).then(function (data) {

                  if (!data || !data[0] || !data[0].value || !data[0].value.result) {
                      // Leave the location as in location_key
                      return;
                  }

                  // Choose first item in the result as the place looking for
                  var result = data[0].value.result;

                  if (result.address_components && result.address_components.length > 0) {
                      scope.location.push(googleMaps.getCityName(result.address_components));
                      scope.searchUrl = '/jobs' + encodeURIComponent(encodeUrlQuery(searchObj));
                  }

                  hRedirect(scope.searchUrl);
              });
          };

          if (!scope.isPrivacyShield) {
              loadRelatedJobs(scope.limit, scope.location, scope.positions, scope.hecs, scope.categories, scope.ignoredJobs);
          } else {
              loadRelatedJobsForBrand(scope.limit, scope.location, scope.categories, scope.ignoredJobs, scope.brandId);
          };


      }

      init();
    }
  }
}]);
